import Judicial from "./Judicial"

export default Judicial
